module.exports = __webpack_public_path__ + "img/MBM.a213059d.png";